"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ComentarioForm_1 = __importDefault(require("../../../../shared/components/ComentarioForm"));
const SugestaoAquisicaoForm_1 = __importDefault(require("../../../../shared/components/SugestaoAquisicaoForm"));
const reactstrap_1 = require("reactstrap");
const react_redux_1 = require("react-redux");
const ModalConstructor_1 = __importDefault(require("../../../../shared/components/ModalConstructor"));
const react_router_dom_1 = require("react-router-dom");
const SuggestionsAndLinksModal = (props) => {
    const { title, viewType, isOpen, setIsOpen, instituicaoRx } = props;
    (0, react_1.useEffect)(() => {
        console.log({
            props
        });
    }, [props]);
    // eslint-disable-next-line react/display-name
    const getContent = (0, react_1.useMemo)(() => () => {
        var _a;
        switch (viewType) {
            case 'C':
                return (react_1.default.createElement(ComentarioForm_1.default, null));
            case 'S':
                return (react_1.default.createElement(SugestaoAquisicaoForm_1.default, { instituicaoRx: instituicaoRx }));
            case 'SP':
                return (react_1.default.createElement(reactstrap_1.Row, { className: "mb-3" },
                    react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: (_a = instituicaoRx === null || instituicaoRx === void 0 ? void 0 : instituicaoRx.msg_suporte_consulta) !== null && _a !== void 0 ? _a : '',
                            } }))));
            default:
                return null;
        }
    }, [viewType, instituicaoRx]);
    // @ts-ignore
    return (react_1.default.createElement(ModalConstructor_1.default, { closeable: true, closeAction: true, size: "xl", title: title, open: isOpen, setOpen: setIsOpen }, getContent()));
};
const mapStateToProps = (state) => ({
    instituicaoRx: state.instituicao.data,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)((0, react_router_dom_1.withRouter)(SuggestionsAndLinksModal));
